import classNames from 'classnames';
import styles from './JumboCard.module.scss';
import { Heading, Picture } from 'ui/components';

export interface JumboCardProps {
	cardActionLinkText?: string;
	cardActionLinkTitle?: string;
	cardActionLinkUrl?: string;
	cardLinkUrl?: string;
	className?: string;
	heading?: string;
	image?: Umbraco.Image;
	kicker?: string;
	text?: string;
}

export const JumboCard: React.FC<JumboCardProps> = ({ cardActionLinkText, cardLinkUrl, className, heading, image, kicker, text }) => (
	<div className={classNames(styles.JumboCard, className)}>
		<a className={styles.JumboCard_link} href={cardLinkUrl}>
			{image && <Picture url={image?.url} properties={image.properties} sizes="100vw" className={styles.JumboCard_mediabox} />}
			<div className={styles.JumboCard_textbox}>
				<div className={styles.JumboCard_kicker}>{kicker}</div>
				<Heading headingLevel="h1" style="xl" className="JumboCard_heading">
					{heading}
				</Heading>
				<div className={styles.JumboCard_text} dangerouslySetInnerHTML={{ __html: text }}></div>
				<div className={classNames(styles.JumboCard_action, 'Action Action___dark Action__block')}>{cardActionLinkText}</div>
			</div>
		</a>
	</div>
);
